import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { removeTokens } from './utils/auth'
import './App.css'
import Login from './components/Login'
import Register from './components/Register'
import AdminDashboard from './components/AdminDashboard'
import VerifyResult from './components/VerifyResult'
import { apiFetch } from './utils/api'

function App() {
  const [currentView, setCurrentView] = useState('login')
  const [adminUser, setAdminUser] = useState(null)

  // Auto-login on mount if valid tokens exist
  useEffect(() => {
    const tryAutoLogin = async () => {
      try {
        const res = await apiFetch('/api/profile')
        if (res.ok) {
          const data = await res.json()
          // If admin, enter admin view
          if (data.user?.role?.name === 'admin') {
            handleAdminLogin(data.user)
          }
        }
      } catch (err) {
        console.error('Auto-login error:', err)
      }
    }
    tryAutoLogin()
  }, [])

  // Redirect to login when both access and refresh tokens have expired
  useEffect(() => {
    const handleSessionExpired = () => {
      setAdminUser(null)
      setCurrentView('login')
    }
    globalThis.addEventListener('auth:session-expired', handleSessionExpired)
    return () => globalThis.removeEventListener('auth:session-expired', handleSessionExpired)
  }, [])

  const switchToRegister = () => {
    setCurrentView('register')
  }

  const switchToLogin = () => {
    setCurrentView('login')
    setAdminUser(null)
  }

  const handleAdminLogin = (user) => {
    setAdminUser(user)
    setCurrentView('admin')
  }

  const handleLogout = async () => {
    try {
      // Always call logout endpoint to clear authentication cookies server-side
      await apiFetch('/api/logout', { method: 'POST' })
    } catch (err) {
      console.error('Logout error:', err)
    } finally {
      // Clean up client-side tokens and reset view
      removeTokens()
      setAdminUser(null)
      setCurrentView('login')
    }
  }

  const renderCurrentView = () => {
    switch (currentView) {
      case 'login':
        return <Login onSwitchToRegister={switchToRegister} onAdminLogin={handleAdminLogin} />
      case 'register':
        return <Register onSwitchToLogin={switchToLogin} />
      case 'admin':
        return <AdminDashboard user={adminUser} onLogout={handleLogout} />
      default:
        return <Login onSwitchToRegister={switchToRegister} onAdminLogin={handleAdminLogin} />
    }
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/verify/:token" element={<VerifyResult />} />
          <Route path="/*" element={renderCurrentView()} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
